import {
    Component,
    Input,
    Signal,
    ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatListItem } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SideNavigationIconLink } from '../../../../core/models/navigation-icon-link';
import { UserStateService } from '../../../../modules/user/shared/services/user-state/user-state.service';
import { SidenavItemLinkComponent } from '../sidenav-item-link/sidenav-item-link.component';

@Component({
    selector: 'app-sidenav-item',
    templateUrl: './sidenav-item.component.html',
    styleUrl: './sidenav-item.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatListItem,
        CommonModule,
        MatTooltipModule,
        RouterModule,
        SidenavItemLinkComponent,
    ],
})
export class SidenavItemComponent {
    @Input() item!: SideNavigationIconLink;
    @Input() isCollapsed!: boolean;
    @Input() isMember!: boolean;
    @Input() isCustomer!: boolean;

    isMasqueraded: Signal<boolean> = this.userStateService.isMasqueraded;

    constructor(private readonly userStateService: UserStateService) {}

    shouldShow(): boolean {
        if (this.item.onlyShowWhenCollapsed) {
            return this.isCollapsed;
        }

        if (this.item.onlyShowWhenCustomerIsMember && this.isCustomer) {
            return this.isMember;
        }

        return true;
    }
}
